module.exports = __webpack_public_path__ + "public/StoreIcon/documentUpload.svg?d531d510";